import firestore, { Timestamp } from 'firebase/firestore';

export class MessagesDeProducteurs {
    idMessagesDeProducteur?: string;

    idProducteur?: string;

    titre?: string;

    description?: string;

    numberOfViews?: number;

    photos?: File[] | string[];

    createdDate?: Timestamp;

    constructor({
        idMessagesDeProducteur,
        idProducteur,
        titre,
        description,
        numberOfViews,
        photos,
        createdDate
    }: {
        idMessagesDeProducteur: string;
        idProducteur: string;
        titre: string;
        description: string;
        numberOfViews: number;
        photos: File[] | string[];
        createdDate: Timestamp;
    }) {
        this.idMessagesDeProducteur = idMessagesDeProducteur;
        this.idProducteur = idProducteur;
        this.titre = titre;
        this.description = description;
        this.numberOfViews = numberOfViews;
        this.photos = photos;
        this.createdDate = createdDate;
    }
}

export const MessagesDeProducteursConverter: firestore.FirestoreDataConverter<MessagesDeProducteurs> =
    {
        toFirestore(messagesDeProducteurs) {
            return {
                idMessagesDeProducteur: messagesDeProducteurs.idMessagesDeProducteur,
                idProducteur: messagesDeProducteurs.idProducteur,
                titre: messagesDeProducteurs.titre,
                description: messagesDeProducteurs.description,
                numberOfViews: messagesDeProducteurs.numberOfViews,
                photos: messagesDeProducteurs.photos,
                createdDate: messagesDeProducteurs.createdDate
            };
        },
        fromFirestore(snapshot, options): MessagesDeProducteurs {
            const data = snapshot.data(options);
            return new MessagesDeProducteurs({
                idMessagesDeProducteur: data.idMessagesDeProducteur,
                idProducteur: data.idProducteur,
                titre: data.titre,
                description: data.description,
                numberOfViews: data.numberOfViews,
                photos: data.photos,
                createdDate: data.createdDate
            });
        }
    };
